import { Box, Paper, Typography } from "@mui/material";
import React from "react";

function Detail({ details }) {
  return (
    <Box>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "2rem",
          padding: "1.5rem 1.5rem",
          flexWrap: "wrap",
        }}
      >
        {details.map((detail) => {
          debugger;
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                padding: "0rem 1.5rem",
              }}
            >
              {Object.keys(detail).map((obj) => {
                return (
                  <>
                    <Typography
                      variant="span"
                      fontWeight={"bold"}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {obj} :
                      <Typography variant="span" fontWeight={"300"}>
                        {" "}
                        {detail[obj]}
                      </Typography>
                    </Typography>
                  </>
                );
              })}
            </Box>
          );
        })}
      </Paper>
    </Box>
  );
}

export default Detail;
